import { LTTB } from 'downsample';
import { unzip } from 'lodash';

import { AxisId } from 'ff/debrief/models';
import { tracklogPointIndex } from 'ff/debrief/utils';

type Point = [number, number];

const DOWN_SAMPLE_RATE = 1000;

const {
    timestamp,
    indicatedAirSpeed,
    groundSpeed,
    altitudeFeet,
    aboveGroundLevel,
    bankDeg,
    pitchDeg,
    gLoad,
    terrainElevation,
} = tracklogPointIndex;

function createDownSampler(dataPoint: number) {
    return (points: number[][]): [number[], number[]] => {
        const timeSpeed = points.map<Point>(p => [p[timestamp], p[dataPoint]]);
        const downSampled = LTTB(timeSpeed, DOWN_SAMPLE_RATE) as Point[];
        const [timeStamps, data] = unzip(downSampled);
        return [timeStamps, data];
    };
}

export const downSampleAirspeed = createDownSampler(indicatedAirSpeed);
export const downSampleGroundSpeed = createDownSampler(groundSpeed);
export const downSampleAltitude = createDownSampler(altitudeFeet);
export const downSampleAboveGroundLevel = createDownSampler(aboveGroundLevel);
export const downSampleBank = createDownSampler(bankDeg);
export const downSamplePitch = createDownSampler(pitchDeg);
export const downSampleGLoad = createDownSampler(gLoad);
export const downSampleTerrain = createDownSampler(terrainElevation);

export function getDownSampler(axisId: AxisId) {
    switch (axisId) {
        case 'altitude':
            return downSampleAltitude;
        case 'above_ground_level':
            return downSampleAboveGroundLevel;
        case 'airspeed':
            return downSampleAirspeed;
        case 'ground_speed':
            return downSampleGroundSpeed;
        case 'pitch':
            return downSamplePitch;
        case 'bank':
            return downSampleBank;
        case 'g_load':
            return downSampleGLoad;
        case 'terrain_elevation':
            return downSampleTerrain;
        default:
            throw new Error('no down sampler found for selected axis');
    }
}
